<div id="location-display" class="d-flex d-none d-md-flex" [style.padding-left]="(isLoggedIn | async) ? null : '16px'">
    @for (loc of locationDisplay; track loc; let i = $index) {
        <span>
            <a
                [routerLink]="getBreadcrumbNavLink(loc)"
                [ngClass]="{ 'link-disabled': !getBreadcrumbNavLink(loc) }"
                class="white">
                {{ loc.charAt(0).toUpperCase() + loc.slice(1) }}
            </a>
            @if (i < locationDisplay.length - 1) {
                <span class="arcus-chevron-right"></span>
            }
        </span>
    }
</div>
